import React from 'react';
import {
  Navigate,
  createBrowserRouter,
} from 'react-router-dom';

import {
  Login,
  UseApp,
  SignUp,
  HTSSignUp,
  Handspring,
  HTSProfileSetup,
  ProfileSetup,
  ConfirmEmail,
  ResetPassword,
  ForgotPassword,
  LoginWithToken,
  PaymentRequired,
  SignUpWithPurchase,
  RedirectToDocument,
  SitePersonalization,
} from 'web-auth-containers';

import MainLayout from './MainLayout';

import privateRoutes from './privateRoutes';

const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: privateRoutes,
  },
  {
    path: '/login',
    Component: Login,
  },
  {
    path: '/use_app',
    element: <UseApp />,
  },
  {
    path: '/get_app',
    element: <UseApp getApp />,
  },
  {
    path: '/forgot-password',
    Component: ForgotPassword,
  },
  {
    path: '/reset/:token',
    Component: ResetPassword,
  },
  {
    path: '/signup',
    Component: SignUp,
  },
  {
    path: '/profile_setup',
    Component: ProfileSetup,
  },
  {
    path: '/site_personalization',
    Component: SitePersonalization,
  },
  {
    path: '/payment_required',
    Component: PaymentRequired,
  },
  {
    path: '/accessToken',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/accessToken/:token',
    Component: LoginWithToken,
  },
  {
    path: '/confirm/:token',
    Component: ConfirmEmail,
  },
  {
    path: '/product/:slug',
    element: <SignUpWithPurchase />,
  },
  {
    path: '/product_plan/:slug',
    element: <SignUpWithPurchase isPlan />,
  },
  {
    path: '/test_product/:slug',
    element: <SignUpWithPurchase isTest />,
  },
  {
    path: '/test_product_plan/:slug',
    element: <SignUpWithPurchase isTest isPlan />,
  },
  {
    path: '/view_document/:id',
    Component: RedirectToDocument,
  },
  {
    path: '/hts',
    Component: HTSSignUp,
  },
  {
    path: '/hts-setup',
    Component: HTSProfileSetup,
  },
  {
    path: '/handspring',
    Component: Handspring,
  },
  {
    path: '/:slug',
    element: <SignUpWithPurchase requestWithSlug />,
  },
]);

export default router;
